import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '../../store/services/session.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { IUserSessionData, UserType } from '../../store/models/user.model';
import { BaseDataSource } from '../../datasources/base.datasource';
import { IContactGroup, IContactItem } from '../../store/models/contact.model';
import {
  DataSourceParams,
  EFilterSize,
  EFilterType,
  ETableColumnType,
  ITableColumn,
  ITableFIlterGroup
} from '../../store/models/table.model';
import { ApiDataSource } from '../../datasources/api.datasrouce';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { EmailPositionComponent } from '../contacts-listing/email-position/email-position.component';
import { ButtonColor, ButtonSize } from '../../store/models/button.model';
import {
  ManagerGroupSelectorComponent
} from '../contacts-listing/manager-group-selector/manager-group-selector.component';
import { IUserContactGroup } from '../../store/models/user-group.model';
import { openDialog, openSnackbar } from '../../store/actions/page.action';
import { ButtonSelectComponent } from '../../shared/ui/button-select/button-select.component';
import { EInfoSelectItemType } from '../../store/models/select.model';
import { Store } from '@ngrx/store';
import { IReducers } from '../../store/reducers';
import { ContactsService } from '../../store/services/contacts.service';
import { AccountService } from '../../store/services/account.service';
import { IAccount } from '../../store/models/account.model';
import { updateLeftMenuCount } from '../../store/actions/meeting.action';
import { RContentComponent } from '../../dialogs/quick-response/r-content.component';
import { SentToCampignDialogComponent } from '../../dialogs/sent-to-campign-dialog/sent-to-campign-dialog.component';
import * as moment from 'moment';
import { TableComponent } from '../../shared/ui/table/table.component';
import { ContactActivityComponent } from '../../dialogs/contact-activity/contact-activity.component';
import { DialogData } from '../../store/models/dialog.model';
import { InfoTipsComponent } from '../../dialogs/info-tips/info-tips.component';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { FailedMovedContactsDialogComponent } from '../user-groups-listing/failed-moved-contacts-dialog/failed-moved-contacts-dialog.component';

@Component({
  selector: 'app-contacts-search',
  templateUrl: './contacts-search.component.html',
  styleUrls: ['./contacts-search.component.scss']
})
export class ContactsSearchComponent implements OnInit, OnDestroy {
  @ViewChild('tableComponent', { static: true }) tableComponent: TableComponent;

  sessionData: IUserSessionData;
  dataSource: BaseDataSource<IContactItem>;
  tableDataSourceParams: DataSourceParams = {
    sortAttr: 'contact_id',
    sortDir: 'desc',
    page: 1,
    pageSize: 10,
    filters: {}
  };
  tableReady: boolean;
  oneTimeMessageWithContacts: boolean;
  groups: IContactGroup[] = [];
  availableAccounts: IAccount[] = [];
  cpgns = [];
  tableColumns: ITableColumn<IContactItem>[] = [];
  tableFiltersGroups: ITableFIlterGroup[] = [];
  tags: any[] = [];


  private readonly destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly sessionService: SessionService,
    private readonly http: HttpClient,
    private readonly store: Store<IReducers>,
    private readonly contactsService: ContactsService,
    private readonly accountService: AccountService,
    private readonly router: Router
  ) { }

  checkFilterAv(value) {
    if (
      !value || value === 'undefined' || value === '' ||
      value.length === 0
    ) {
      return false;
    }
    return true;
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((queryParams) => {
        this.tableReady = false;
        let search = queryParams.search;

        if (Array.isArray(search)) {
          search = search.join(',');
        }

        if (!search && queryParams.tags) {
          this.router.navigate(['/user_contacts', 'search']);
          return;
        }
        this.accountService.getTags().subscribe(
          tags => {
            this.tags = tags.items;

            this.tableFiltersGroups = [
              {
                filters: [
                  {
                    type: EFilterType.SEARCH,
                    size: EFilterSize.HALF,
                    items: [
                      {
                        id: 'search',
                        label: ' Enter the Keyword for Search',
                        icon: 'search',
                        value: !queryParams.tags ? search : ''
                      },
                    ],
                    applyFilter: false,
                    onFilterChange: value => this.router.navigate(['/user_contacts', 'search'], {
                      queryParams: {
                        search: value,
                      }
                    })
                  },
                  {
                    label: 'Tags',
                    type: EFilterType.TAGS,
                    size: EFilterSize.HALF,
                    items: this.tags.map(t => ({
                      id: t.id,
                      label: t.name,
                      value: t.name,
                      selected: Array.isArray(queryParams.search) ? search.indexOf(t.name) !== -1 : t.name === search
                    })),
                    applyFilter: false,
                    onFilterChange: value => this.router.navigate(['/user_contacts', 'search'], {
                      queryParams: {
                        search: value,
                        tags: true
                      }
                    })
                  }
                ]
              }
            ];

            this.sessionService
              .onReady()
              .pipe(takeUntil(this.destroy$))
              .subscribe(sessionData => {
                this.sessionData = sessionData;

                this.contactsService.getContactGroups(this.sessionData.id)
                  .subscribe(groups => {
                    this.groups = groups;

                    if (
                      this.sessionData.user_type === UserType.PARTNER ||
                      this.sessionData.user_type === UserType.MANAGER
                    ) {
                      this.accountService
                        .getAccountsBasicInfo(UserType.SINGLE_USER)
                        .subscribe(result => {
                          this.availableAccounts = result.items;
                          this.initTable(queryParams);
                        });
                    } else {
                      this.contactsService.getActiveCampaigns().subscribe(r => {
                        if (r && r.items) {
                          this.cpgns = r.items.map(item => {
                            return {
                              id: item.campaign_id,
                              value: item.campaign_name,
                            };
                          });
                        }
                        this.initTable(queryParams);
                      });
                    }
                  });
              });
          });
    });
  }

  initTable(queryParams: any) {
    let params = '?';
    if (this.checkFilterAv(queryParams.search) && !queryParams.tags) {
      params = params + 'search=' + queryParams.search;
    }
    if (this.checkFilterAv(queryParams.tags)) {
      if (this.checkFilterAv(queryParams.search)) {
        params = params + '&';
      }
      params = params + 'tags=' + queryParams.search.toString();
    }
    this.oneTimeMessageWithContacts = true;
    this.dataSource = new ApiDataSource<IContactItem>(
      this.http,
      environment.apiUrl + '/v1/contacts' + params,
    );
    this.setContactColumns();
    this.tableReady = true;
  }

  setContactColumns() {
    let columns: ITableColumn<IContactItem>[] = [
      {
        id: 'contact_firstname',
        title: 'Contact',
        sortable: true,
        getFaIconPrefix: (element: IContactItem) => {
          if (element.duplicate_contact) {
            return faCopy
          }
          return null;
        },
        renderer: (element: IContactItem) => {
          if(!element.contact_firstname && !element.contact_lastname) {
            return element.contact_email;
          }
          return `${element.contact_firstname || ''} ${
            element.contact_lastname || ''
          }`;
        },
      },
      {
        id: 'contact_title',
        title: 'Title',
        sortable: true,
      },
      {
        id: 'contact_company',
        title: 'Company',
        sortable: true,
      },
      {
        id: 'email_position',
        title: 'Position',
        sortable: true,
        type: ETableColumnType.ANCHOR,
        anchorHandler: (column, row) =>
          this.store.dispatch(openDialog({
            dialogData: {
              content: EmailPositionComponent,
              componentData: {
                contactId: row.contact_id,
                userTimezone: this.sessionData.time_zone,
                contactStatus: row.contact_status,
              },
              dialogWidth: '300px',
              title: 'Message dates',
              canClose: true,
              buttons: [{
                text: 'Ok',
                actAsClose: true,
                onClick: dialog => dialog.close(),
                color: ButtonColor.GREEN,
                size: ButtonSize.NORMAL,
              }],
            },
          })),
      },
      {
        id: 'group_name',
        title: 'Group',
        type: ETableColumnType.COMPONENT,
        componentProperties: {
          component: ManagerGroupSelectorComponent,
          mapData: {
            data: {
              instance: 'column',
            },
            groups: {
              instance: 'static',
              target: this.groups,
            },
          },
        },
      },
    ];

    if (
      this.sessionData.permissions &&
      this.sessionData.permissions.can_find_template
    ) {
      columns.push({
        id: 'response',
        title: 'Reply',
        type: ETableColumnType.COMPONENT,
        componentProperties: {
          component: ButtonSelectComponent,
          mapData: {
            buttonProperties: {
              instance: 'static',
              target: {
                text: 'Select',
                size: ButtonSize.SMALL,
                color: ButtonColor.ORANGE,
              },
            },
            selection: {
              instance: 'function',
              target: rowItem => {
                return selectItem =>
                  this.openResponseDialog(rowItem, selectItem);
              },
            },
            items: {
              instance: 'function',
              target: (item: IContactItem) => {
                const items = [
                {
                  label: 'Opportunities',
                  type: EInfoSelectItemType.TYPE_NORMAL,
                  tag: 'main',
                  dialogContent: this.getDialogData('opportunities'),
                  children: [
                    {
                      label: 'Meetings',
                      tag: 'meeting',
                      type: EInfoSelectItemType.TYPE_NORMAL,
                      dialogContent: this.getDialogData('meeting'),
                    },
                    {
                      label: 'Order/Quote',
                      tag: 'order',
                      type: EInfoSelectItemType.TYPE_NORMAL,
                      dialogContent: this.getDialogData('order'),
                    },
                  ],
                },
                {
                  label: 'Cycle',
                  tag: 'cycle',
                  type: EInfoSelectItemType.TYPE_NORMAL,
                  dialogContent: this.getDialogData('cycle'),
                },
                {
                  label: 'Follow up',
                  tag: 'followup',
                  type: EInfoSelectItemType.TYPE_NORMAL,
                  dialogContent: this.getDialogData('follow_up'),
                },
                {
                  label: 'Inactive',
                  tag: 'inactive',
                  type: EInfoSelectItemType.TYPE_NORMAL,
                  dialogContent: this.getDialogData('inactive'),
                },
                {
                  label: 'Remove',
                  tag: 'remove',
                  type: EInfoSelectItemType.TYPE_NORMAL,
                  dialogContent: this.getDialogData('remove'),
                },
                {
                  label: 'Conversation',
                  tag: 'conversation',
                  type: EInfoSelectItemType.TYPE_NORMAL,
                  dialogContent: this.getDialogData('conversation'),
                },
                {
                  label: 'Send Email',
                  tag: 'send-email',
                  type: EInfoSelectItemType.TYPE_NORMAL,
                  value: 'send_email',
                }
              ];

              if(!item.duplicate_contact) {
                items.push({
                  label: 'Send to campaign',
                  tag: 'send-to-campaign',
                  type: EInfoSelectItemType.TYPE_NORMAL,
                  value: 'send_to_campaign',
                });
              }
              return items;
            }

            },
          },
        },
      });
    }

    columns = [
      ...columns,
      {
        id: 'edit',
        title: 'Edit',
        type: ETableColumnType.BUTTON,
        getButtonProperties: (item: IContactItem) => {
          return {
            color: ButtonColor.ORANGE,
            size: ButtonSize.SMALL,
            text: item.account_id === this.sessionData.id ? 'Edit' : 'View',
          };
        },
        route: (item: IContactItem) => `/user_contacts/${item.contact_id}/edit`,
      },
    ];

    columns = [
      ...columns,
      {
        id: 'activity',
        title: 'Activity',
        type: ETableColumnType.BUTTON,
        buttonProperties: {
          color: ButtonColor.GREEN,
          size: ButtonSize.SMALL,
          text: 'Activity',
          onClick: (item: IContactItem) => this.openActivityDialog(item),
        },
      },
    ];
    if (this.sessionData.user_type !== UserType.SINGLE_USER) {
      if (this.sessionData.user_type === UserType.MASTER) {
              columns.push({
                id: 'account_firstname',
                title: 'Account Name',
                renderer: (element: IContactItem) => {
                  return `${element.account_firstname} ${element.account_lastname}`;
                },
              });
            } else {
              columns.push({
                id: 'account_firstname',
                title: 'Rep-Name',
                type: ETableColumnType.SELECT,
                getSelectProperties: (element: IContactItem) => ({
                  disabled: element.duplicate_contact,
                  disabledPopupContent: "Cannot change owner of duplicated contacts.<br/>Please use the MAKE PRIMARY or DELETE actions",
                  label: 'Move to',
                  confirmMessage: `Warning - you are about to move a contact group from one rep to another, The contact group will be moved to the new reps account and automatically assigned to no campaign, You can use the edit/merge feature to move the contact group to an existing or new campaign, All campaign positions and replay actions will remain intact and all history for the contacts will be moved`,
                  onSelection: (value, table, row: IUserContactGroup) => {
                    this.contactsService
                      .moveContactToAccount(row.contact_id, value)
                      .subscribe(
                        response => {
                          if (response && response.failed && response.failed.length) {
                            this.store.dispatch(openDialog({
                              dialogData: {
                                title: 'Move contacts status',
                                canClose: true,
                                content: FailedMovedContactsDialogComponent,
                                componentData: {
                                  failed: response.failed,
                                }
                              }
                            }));
                          }
                          const targetAccount = this.availableAccounts.find(
                            a => a.account_id === value,
                          );
                          if (targetAccount) {
                            this.store.dispatch(
                              openSnackbar({
                                snackbarData: {
                                  data: {
                                    type: 'success',
                                    message: `Contact moved to ${targetAccount.first_name} ${targetAccount.last_name}`,
                                  },
                                  verticalPosition: 'bottom',
                                },
                              }),
                            );
                          }
                          table.refresh();
                        },
                        error => {
                          if (
                            error &&
                            error instanceof HttpErrorResponse &&
                            error.status === 400 &&
                            error.error
                          ) {
                            this.store.dispatch(
                              openSnackbar({
                                snackbarData: {
                                  data: {
                                    type: 'error',
                                    message: error.error,
                                  },
                                  verticalPosition: 'bottom',
                                },
                              }),
                            );
                          }
                        },
                      );
                  },
                  buildItems: row => {
                    if (!this.availableAccounts) {
                      return [];
                    }
                    return this.availableAccounts.map(account => {
                      return {
                        label: `${account.first_name} ${account.last_name}`,
                        value: account.account_id,
                        selected: row.account_id === account.account_id,
                      };
                    });
                  },
                }),
              });
            }
    }
    columns = [
      ...columns,
      {
        id: 'contact_vip',
        title: 'VIP',
        type: ETableColumnType.CHECKBOX,
        sortable: true,
        checkboxProperties: {
          disabled: !this.sessionData.vip_mode,
          label: 'Vip',
          Change: (val: IContactItem) => this.toggleContactVip(val),
        },
      },
      {
        id: 'contact_status',
        title: 'Status',
        route: (element: IContactItem) => {
          if (element.contact_status === 'Inactive') {
          }
        },
      },
    ];

    if (this.sessionData.user_type === UserType.MASTER || this.sessionData.user_type === UserType.MANAGER) {
      columns.push({
        id: 'delete_contact',
        title: 'Delete',
        type: ETableColumnType.BUTTON,
        buttonProperties: {
          color: ButtonColor.RED,
          size: ButtonSize.SMALL,
          text: 'Delete',
          buttonDisabled: (element: IContactItem) => {
            if (this.sessionData.user_type === UserType.MASTER) {
              return false;
            }
            return !element.duplicate_contact;
          },
          onClick: (item: IContactItem) =>
            this.store.dispatch(
              openDialog({
                dialogData: {
                  content: item.duplicate_contact ? 'This email address is duplicated across your subordinates. You are about to delete the duplicated entry. </br>History associated with this particular contact id will be deleted. </br>The primary contact will remain intact.' : `Contact will be permanently deleted from your list. All associated messages, campaign email records and reply positions will be removed. <br/> Are you sure you want to permanently delete contact ID ${item.contact_id}  with email address ${item.contact_email}?`,
                  title: item.duplicate_contact ? 'Delete a duplicated contact' : `Delete contact ${item.contact_email} with ID ${item.contact_id}`,
                  buttons: [
                    {
                      text: 'Yes',
                      size: ButtonSize.NORMAL,
                      color: ButtonColor.RED,
                      onClick: dialog =>
                        this.contactsService
                          .deleteContact(item.contact_id)
                          .subscribe(
                            () => {
                              this.store.dispatch(
                                openSnackbar({
                                  snackbarData: {
                                    data: {
                                      message: 'Contact successfully deleted',
                                      type: 'success',
                                    },
                                  },
                                }),
                              );
                              this.dataSource.refresh();
                              dialog.close();
                            },
                            error =>
                              this.store.dispatch(
                                openSnackbar({
                                  snackbarData: {
                                    data: {
                                      message: error.error,
                                      type: 'error',
                                    },
                                  },
                                }),
                              ),
                          ),
                    },
                  ],
                  canClose: true,
                },
              }),
            ),
        },
      });
    }

    if(this.sessionData.user_type === UserType.MANAGER) {
      columns.push({
        id: 'make_primary',
        title: 'Make Primary',
        type: ETableColumnType.BUTTON,
        buttonProperties: {
          color: ButtonColor.BLUE,
          size: ButtonSize.SMALL,
          text: 'Make Primary',
          buttonDisabled: (element: IContactItem) => {
            return !element.duplicate_contact;
          },
          onClick: (item: IContactItem) =>
            this.store.dispatch(openDialog({
        dialogData: {
          content: `This contact is identified as a duplicate. The same email address is already present within one of your subordinates' contact groups. </br>The other contact is indicated as primary, since it was created earlier. </br>You can change the primary status of the duplicated contacts and decide which subordinate  should be able to utilize all the Retreva's actions.</p>
<p>In addition, you can later delete duplicated secondary contacts`,
          title: 'Switch primary status of duplicated contact',
          buttons: [
            {
              text: 'Yes',
              size: ButtonSize.NORMAL,
              color: ButtonColor.BLUE,
              onClick: dialog  => 
                this.contactsService
                  .makeContactPrimary(item.contact_id)
                  .subscribe(
                    () => {
                      this.store.dispatch(
                        openSnackbar({
                          snackbarData: {
                            data: {
                              message: 'Contact successfully made primary',
                              type: 'success',
                            },
                          },
                        }),
                      );
                      this.dataSource.refresh();
                    },
                    error => {
                      this.store.dispatch(
                        openSnackbar({
                          snackbarData: {
                            data: {
                              message: error.error,
                              type: 'error',
                            },
                          },
                        }),
                      );
                    }
                  ),
                },
          ],
          canClose: true, 
        }
      },
      )),
    },
    });
    }

    this.tableColumns = columns;
  }

  ngOnDestroy() {
      this.destroy$.next();
  }

  toggleContactVip(val: IContactItem): void {
    this.contactsService
      .setContactVipStatus(val.contact_id, !val.contact_vip)
      .subscribe(res => {
        if (this.tableComponent) {
          this.tableComponent.refresh();
        }
      });
  }

  openActivityDialog(item: IContactItem): void {
    this.store.dispatch(
      openDialog({
        dialogData: {
          title: `Contact History for ${item.contact_firstname} ${item.contact_lastname}`,
          content: ContactActivityComponent,
          componentData: {
            contactId: item.contact_id,
            contactReplayAction: item.action_name,
            isContactDuplicate: item.duplicate_contact,
          },
          dialogMinWidth: '1200px',
          canClose: true,
        },
      }),
    );
  }

  getDialogData(type): DialogData {
    return {
      content: InfoTipsComponent,
      title: 'Tips',
      canClose: true,
      dialogMinWidth: '700px',
      componentData: {
        type,
      },
    };
  }

  private openResponseDialog(rowItem, selectedItem) {
    switch (selectedItem.tag) {
      case 'main':
        break;
      case 'got-it':
        this.contactsService
          .quickResponse({ contact_id: rowItem.contact_id }, 'okgotit')
          .subscribe(response => {
            this.store.dispatch(updateLeftMenuCount({ data: {} }));
          });
        break;
      case 'send-mail':
        this.store.dispatch(
          openDialog({
            dialogData: {
              title: selectedItem.label,
              content: RContentComponent,
              componentData: {
                data: selectedItem,
              },
              dialogMinWidth: '1000px',
              canClose: true,
              buttons: [
                {
                  text: 'Ok',
                  actAsClose: true,
                  color: ButtonColor.GREEN,
                  size: ButtonSize.NORMAL,
                },
                {
                  text: 'Close',
                  actAsClose: true,
                  color: ButtonColor.RED,
                  size: ButtonSize.NORMAL,
                },
              ],
            },
          }),
        );
        break;
      case 'send-to-campaign':
        this.store.dispatch(openDialog({
          dialogData: {
            content: SentToCampignDialogComponent,
            dialogMinWidth: '600px',
            canClose: true,
            title: `Sent ${rowItem.contact_firstname || ''} ${rowItem.contact_lastname || ''} to campaign`,
            buttons: [{
              text: 'Send',
              color: ButtonColor.GREEN,
              size: ButtonSize.NORMAL,
              onClick: (dialog) => {
                if(!dialog.component.componentReady) {
                  return false;
                }
                if (!dialog.dialogForm.valid) {
                  dialog.dialogForm.markAllAsTouched();
                  return;
                }

                const campaignId = dialog.dialogForm.value.campaign_id;
                const groupId = dialog.dialogForm.value.group_id;
                const startDate = moment(dialog.dialogForm.value.start_date).format('YYYY-MM-DD');

                this.contactsService.sendContactToCampaign(
                  rowItem.contact_id,
                  campaignId,
                  groupId,
                  startDate,
                ).subscribe(
                  () => {
                    this.store.dispatch(openSnackbar({
                      snackbarData: {
                        data: {
                          message: 'Contact successfully send to campaign!',
                          type: 'success',
                        },
                      },
                    }));
                    dialog.closeDialog();
                    this.tableComponent.refresh();
                  },
                  err => this.store.dispatch(openSnackbar({
                    snackbarData: {
                      data: {
                        message: err.error,
                        type: 'error',
                      },
                    },
                  })),
                );
              },
            }],
          },
        }));
        break;
      default:
        this.openDialog(rowItem, selectedItem);
        break;
    }
  }

  private openDialog(item, data) {
    this.store.dispatch(
      openDialog({
        dialogData: {
          title: data.label,
          content: RContentComponent,
          componentData: {
            data,
            contact_id: item.contact_id,
            item,
          },
          dialogMinWidth: '1000px',
          canClose: true,
          tips: ['cycle', 'followup', 'meeting', 'inactive', 'remove'].indexOf(data.tag) !== -1 ? 'send-update' : null,
        },
      }),
    );
  }

}
